//import axios from 'axios';
import axios from '../utils/axios';
const API_URL = process.env.REACT_APP_API_URL + "/v1/admin/";


const getAllEmailQueue = (pageNo=0,pageSize=5)=>{
    return axios.get(API_URL+"email-queues?pageNo="+pageNo+"&pageSize="+pageSize)
}
const getEmailQueueById = (id) =>{
    return axios.get(API_URL+"email-queues/"+id)
}
const deleteEmailQueue = (data) => {
    return axios.delete(API_URL+"email-queues",{data:data})
}

const getAllSmsQueue = (pageNo=0,pageSize=5)=>{
    return axios.get(API_URL+"sms-queues?pageNo="+pageNo+"&pageSize="+pageSize)
}
const getSmsQueueById = (id) =>{
    return axios.get(API_URL+"sms-queues/"+id)
}
const deleteSmsQueue = (data) => {
    return axios.delete(API_URL+"sms-queues",{data:data})
}


const getAllCallQueue = (pageNo=0,pageSize=5)=>{
    return axios.get(API_URL+"call-queues?pageNo="+pageNo+"&pageSize="+pageSize)
}
const getCallQueueById = (id) =>{
    return axios.get(API_URL+"call-queues/"+id)
}
const deleteCallQueue = (data) => {
    return axios.delete(API_URL+"call-queues",{data:data})
}


export default {
    getAllEmailQueue,
    getEmailQueueById,
    deleteEmailQueue,
    getAllSmsQueue,
    getSmsQueueById,
    deleteSmsQueue,
    getAllCallQueue,
    getCallQueueById,
    deleteCallQueue
  
}